'use strict';

const decorator = require('./decorator');

/**
 * Validação de CNPJ.
 *
 * Baseado no algoritmo de validação de CNPJ encontrado em:
 * @link http://www.geradorcnpj.com/javascript-validar-cnpj.htm
 *
 * @param {String} cnpj
 *
 * @return {Bool}
 */
exports.validate = function(cnpj)
{
    if (!cnpj) {
        return false;
    }

    // Removendo a máscara.
    cnpj = decorator.unMask(cnpj);

    // Elimina CNPJs invalidos conhecidos.
    if (cnpj === '00000000000000' ||
        cnpj === '11111111111111' ||
        cnpj === '22222222222222' ||
        cnpj === '33333333333333' ||
        cnpj === '44444444444444' ||
        cnpj === '55555555555555' ||
        cnpj === '66666666666666' ||
        cnpj === '77777777777777' ||
        cnpj === '88888888888888' ||
        cnpj === '99999999999999'
    ) {
        return false;
    }
    // Elimina CNPJs invalidos conhecidos.

    // Valida DVs
    var tamanho = cnpj.length - 2;
    var numeros = cnpj.substring(0, tamanho);
    var digitos = cnpj.substring(tamanho);
    var soma    = 0;
    var pos     = tamanho - 7;

    for (var i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
            pos = 9;
        }
    }

    var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(0)) {
        return false;
    }

    tamanho = tamanho + 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;

    for (i = tamanho; i >= 1; i--) {
        soma += numeros.charAt(tamanho - i) * pos--;
        if (pos < 2) {
            pos = 9;
        }
    }

    resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
    if (resultado != digitos.charAt(1)) {
        return false;
    }
    // Valida DVs

    return true;
};
